export class WebStorage {
  constructor(private storeId: string, private adapter = window.localStorage) {}

  get<T extends string | object>(key: string): T | null {
    const value = this.adapter.getItem(this.createKey(key))

    try {
      return JSON.parse(value!)
    } catch {
      return value as T
    }
  }
  set<T>(key: string, value: T): void {
    const valueToSet = isObjectLike(value) ? JSON.stringify(value) : value
    this.adapter.setItem(this.createKey(key), valueToSet)
  }

  remove(key: string): void {
    this.adapter.removeItem(this.createKey(key))
  }

  clear(): void {
    this.adapter.clear()
  }

  getWholeDb(): Record<string, string> {
    return { ...this.adapter }
  }

  private createKey(keyName: string): string {
    return `${this.storeId}.${keyName}`
  }
}

function isObjectLike<O extends object>(val: any): val is O {
  return isDefined(val) && typeof val === 'object'
}
function isDefined<T>(val: any): val is T {
  return val !== undefined
}



// WEBPACK FOOTER //
// ./src/modules/web-storage/web-storage.ts